import Joi from '@hapi/joi';

export const SessionTimeConfigSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group is required`,
        "any.required": `Group is required`,
    }),
    estate: Joi.array().min(1).required().label("Factory").messages({
        "array.min": `At least one Operation Entity is required`,
        "any.required": `Operation Entity is required`,
    }),
    session: Joi.number().valid(1, 2, 3).required().label("Session").messages({
        "any.only": `Session must be 1, 2, or 3`,
        "any.required": `Session is required`,
        "number.base": `Session is required`,
    }),
    startTime: Joi.string().invalid("").required().label("Start Time").messages({
        "any.required": `Start Time is required`,
        "any.invalid": `Start Time is required`,
        "string.empty": `Start Time is required`,
    }),
    endTime: Joi.string().invalid("").required().label("End Time").messages({
        "any.required": `End Time is required`,
        "any.invalid": `End Time is required`,
        "string.empty": `End Time is required`,
    }),
    menuCode: Joi.array().min(1).required().label("Menu Code").messages({
        "array.min": `Menu Code is required`,
        "any.required": `Menu Code is required`,
    }),
};
